// extracted by mini-css-extract-plugin
export default {"nav":"SubcontractorDetails_nav__ibEY4","search":"SubcontractorDetails_search__R6hkb"};